/*
 * @Author: Dong
 * @Date: 2022-05-05 17:07:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-31 14:49:51
 */
import React, { useEffect, useState, useRef } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import Icon from 'root/components/Icon';
import Modal from 'root/components/CommonModal';
import { Button, Form, InputNumber, message, Spin, Tooltip, notification } from 'sup-ui';
import { WrappedFormUtils, FormComponentProps } from 'sup-ui/lib/form/Form';
import messages from './messages';
import styles from './index.less';
import {
  getSuposAllConfig,
  modifySuposConfig,
  getSuposStatusApi,
  unInstall,
  getSummaryApi,
} from 'root/services/manager';
import { operationSuposApi, getBasicInfo } from 'root/services/monitor';

import { getAlarm, setAlarmConfigApi } from 'root/services/alert';
import { alertCheckApi, nextTimeApi, oneClickApi, canleAlertApi } from 'root/services/notice';

import AlertConfig from 'root/components/MonitorManage/AlarmConfig';

import { InstallplatformInfoType } from 'root/pages/InstallSupos/types';
import CheckEnv from './CheckEnv';

import { useAsyncState } from 'root/common/useAsyncState';

import { useSelector, useDispatch } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { envManage } from 'root/pages/EnvManage/store/actions';

import SystemNotice from './SystemNotice';
import ExtendedService from './ExtendedService';
import InstallList from 'root/components/InstallList';
import PopoverDelete from 'root/components/InstallList/TaskItem/PopoverDelete';
import DilatationNode from './DilatationNode';
import supOSLogo from 'root/assets/images/logo_supos.svg';
import moment from 'moment';
import 'moment-timezone';

import ProgressComm from 'root/components/Progress';

const { confirm } = Modal;
interface PropsType {
  form: WrappedFormUtils;
}
let loopTimer: any = null;

export const middleStatusList = ['PENDING', 'RESTARTING', 'STOPPING', 'UPDATING']; // supos的中间状态

const platformFormItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

type Ref = FormComponentProps;

const PlatformManage = (props: PropsType) => {
  const { form } = props;
  const { getFieldDecorator, validateFields } = form;
  const intl = useIntl();
  const dispatch = useDispatch();

  const [alarmConfig, setAlarmConfig] = useAsyncState<any>({}); // 告警阈值信息
  const [baseInfo, setBaseInfo] = useAsyncState<any>({}); //  基本信息
  const [sysTimeData, setSysTimeData] = useAsyncState({}); // 修改系统时间传默认对象
  const [statusText, setStatusText] = useAsyncState<string>(''); // 平台状态文本信息
  const [hostInfo, setHostInfo] = useAsyncState<any>({}); // 主机相关信息
  const [visible, setVisible] = useState(false);
  const [platformConfigvisible, setPlatformConfigVisible] = useState(false);
  const [visibleDilatationNode, setVisibleDilatationNode] = useState(false);
  const [checkEnvVisible, setCheckEnvVisible] = useState(false);

  const [spinning, setSpinning] = useAsyncState(true);

  const [disable, setDisable] = useAsyncState(false);

  const [percent, setPercent] = useAsyncState<any>(0); // 更新中的进度条， 有值的也代表任务状态为更新中
  const [platformInfo, setPlatformInfo] = useAsyncState<InstallplatformInfoType>({
    supos: { reservedPortsForWeb: [] },
  }); // 平台数据 supos信息和端口等
  const { supos } = platformInfo;

  const AlertCongfigRef = useRef<Ref>();
  const DilatationNodeRef = useRef<Ref>();
  const unmountedRef = useRef(false); // 用于标记页面卸载
  const { cluster } = useSelector((state: reducerStates) => state.envManage);
  const { operate } = useSelector((state: reducerStates) => state.install);
  const { acitveKey } = useSelector((state: reducerStates) => state.envManage);

  const [progressData, setProgressData] = useState<any>([]);
  const [loadingObj, setloadingObj] = useState({ name: '', loading: false }); // 加载中对象

  const extendedServiceRef = useRef<any>(null);

  const statusData: { type: string; title: MessageDescriptor; bgColor: string; hidden?: boolean }[] = [
    {
      type: 'start',
      title: messages.start,
      bgColor: 'blue',
      hidden: statusText !== 'stopped', // 只有已停止状态显示启动按钮
    },
    {
      type: 'stop',
      title: messages.stop,
      bgColor: 'red',
      hidden: !['running', 'run_with_high_risk', 'run_with_low_risk'].includes(statusText), // 只有运行中状态显示停止按钮
    },
    {
      type: 'upgrade',
      title: messages.downtimeUpgrade,
      bgColor: 'blue',
      hidden: !['running', 'run_with_high_risk', 'run_with_low_risk', 'stopped'].includes(statusText), // 只有运行中状态显示停止按钮
    },
    {
      type: 'checkEnv',
      title: messages.checkEnv,
      bgColor: '',
      hidden: true, // 8-31号要求提测屏蔽该按钮
    },
    // {
    //   type: 'rollback',
    //   title: messages.rollback,
    //   bgColor: '',
    //   hidden: !['running', 'run_with_high_risk', 'run_with_low_risk', 'stopped'].includes(statusText), // 只有运行中状态显示停止按钮
    // },

    // {   本次迭代暂时屏蔽该功能
    //   type: 'dilatationNode',
    //   title: messages.dilatationNode,
    //   bgColor: '',
    //   hidden: !cluster, // 集群环境并且有可扩容的节点
    // },
  ];

  // 显示组件列表选择Modal
  const clickBtn = (type: string) => {
    if (!extendedServiceRef.current?.clickBtn) return;
    extendedServiceRef.current?.clickBtn(type, 'system');
  };

  // 初始化数据
  useEffect(() => {
    if (acitveKey === '1') {
      getStatus();
      getSummary();
      getBasicInfo();
      alertCheck();
      return;
    }

    notification.destroy();
    clearTimeout(loopTimer);
    loopTimer = null;
  }, [operate, acitveKey]);

  useEffect(() => {
    getData();
    getPlatformInfoFn();
    getAlarmConfigData();
    getSummary();
    return () => {
      // 组件将要卸载 清除定时器和添加标识
      unmountedRef.current = true;
      clearTimeout(loopTimer);
      loopTimer = null;
      notification.destroy();
    };
  }, []);

  const getSummary = () => {
    getSummaryApi().then((res) => {
      setHostInfo(res?.data);
    });
  };

  // 检查告警
  const alertCheck = () => {
    notification.destroy();
    alertCheckApi().then((res) => {
      const { data } = res;
      data.forEach((item: any) => {
        openNotification(item);
      });
    });
  };

  // 7天后再提醒
  const nextTime = (key: string) => {
    nextTimeApi().then(() => {
      notification.close(key);
    });
  };

  useEffect(() => {
    setProgress();
  }, [hostInfo, alarmConfig]);

  // 获取运行状态
  const getStatus = () => {
    getSuposStatusApi({ names: ['supos'] }).then((res: any) => {
      const { data = [{}] } = res;
      const { status, percent } = data[0] || {};

      // 如果是未安装(被卸载),重新刷新页
      if (status === 'NOTINSTALL') {
        const envStatus = JSON.parse(sessionStorage.getItem('envStatus') || '');
        const newData = { ...envStatus, isSuposInstalled: false };
        dispatch(envManage.changeEnvStatus(newData));
        sessionStorage.setItem('envStatus', JSON.stringify(newData));
        window.location.reload();
        return;
      }

      setStatusText(status.toLowerCase());

      setDisable(false);
      setPercent(percent);

      // 如果是中间状态  部分操作不允许
      if (middleStatusList.includes(status)) {
        setDisable(true);
        // 如果是更新中 supos的状态要设置为已停止
        if (status === 'UPDATING') {
          setStatusText('stopped');
        }
      }
      loopGetData();
    });
  };

  // 获取平台信息
  const getData = () => {
    getBasicInfo()
      .then((res: any) => {
        const { data } = res;
        const { auto, systemTime, timezone, ntpIP = [] } = data;

        setBaseInfo(data);
        setSysTimeData({
          timezone,
          isAuto: auto ? 1 : 0,
          systemTime: systemTime,
          ntpIP,
        });
      })
      .finally(() => {
        setSpinning(false);
      });
  };

  // 获取告警阈值信息
  const getAlarmConfigData = () => {
    const params = {
      podName: 'Ubuntu-All',
      namespace: 'Ubuntu-All',
    };
    getAlarm(params).then((res: any) => {
      const data = res?.data?.data[0];
      for (const key in data) {
        if (key.hasOwnProperty(data)) {
          data[key] = data[key] ? String(data[key]) : '';
        }
      }
      setAlarmConfig(data);
    });
  };

  // 弹出消息提醒框
  const openNotification = (data: { [props: string]: any }) => {
    const { type, message, serviceNames = [] } = data;
    let serviceNamesStr = serviceNames?.slice(0, 2).join(',');
    serviceNamesStr = serviceNames?.length > 2 ? serviceNamesStr + '...' : serviceNamesStr;
    const btns: { [key: string]: any } = {
      EMAIL_ALERT_CONFIG: [
        {
          title: intl.formatMessage(messages.configuration),
          type: 'primary',
          callback: () => {
            dispatch(
              envManage.changeEnvStatus({
                acitveKey: '6',
              }),
            );
          },
        },
        {
          title: intl.formatMessage(messages.notConfigured),
          tip: intl.formatMessage(messages.remindMeLater),
          callback: () => {
            nextTime(key);
          },
        },
      ],
      SERVICE_ALERT_ENABLED: [
        {
          title: intl.formatMessage(messages.oneClick),
          type: 'primary',
          callback: () => {
            oneClickApi().then(() => {
              notification.close(key);
            });
          },
        },
        {
          title: intl.formatMessage(messages.notCurrentlyAvailable),
          callback: () => {
            canleAlertApi().then(() => {
              notification.close(key);
            });
          },
        },
      ],
    };

    const title: { [key: string]: string } = {
      EMAIL_ALERT_CONFIG: intl.formatMessage(messages.emailAlertConfig),
      SERVICE_ALERT_ENABLED: intl.formatMessage(messages.serveicAlertEnable),
    };

    const key = `open${Date.now()}`;
    notification.open({
      message: <div style={{ textAlign: 'center', color: '#005DC8' }}>{title[type]}</div>,
      placement: 'bottomRight',
      duration: null,
      description: message || (
        <div>
          {intl.formatMessage(messages.serviceTipStart)}
          <span title={serviceNames?.join(',')} style={{ fontWeight: 'bold', cursor: 'pointer' }}>
            ({serviceNamesStr})
          </span>
          {intl.formatMessage(messages.serviceTipEnd)}
        </div>
      ),
      btn: btns[type].map((item: any) => (
        <Button type={item.type} onClick={item.callback} key={item.title} size="small" title={item.tip}>
          {item.title}
        </Button>
      )),
      key,
    });
  };

  // 处理进度数据
  const setProgress = () => {
    const { cpuInfo, diskInfo, memoryInfo, extService, service, host } = hostInfo;
    if (!cpuInfo) return;
    const { limit: cpuLimit, used: cpuUsed, unit: cpuUnit, total: cpuTotal }: any = cpuInfo;
    const { limit: memoryLimit, used: memoryUsed, unit: memoryUnit, total: memoryTotal }: any = memoryInfo;
    const { limit: diskLimit, used: diskUsed, unit: diskUnit, total: diskTotal }: any = diskInfo;

    const { total: totalExtService, running: totalExtRunningService }: any = extService;
    const { total: totalService, running: totalRunningService }: any = service || {};
    const { total: totalHost, running: totalRunning }: any = host;

    const progressList = [
      {
        type: 'CPU',
        title: messages.CPU,
        bgColor: 'blue',
        hidden: cluster,
        count: cpuTotal,
        used: cpuUsed,
        unit: cpuUnit,
        warning: Number(cpuUsed) > Number(cpuLimit),
      },
      {
        type: 'memory',
        title: messages.memory,
        bgColor: '',
        hidden: cluster,
        count: memoryTotal,
        used: memoryUsed,
        unit: memoryUnit,
        warning: Number(memoryUsed) > Number(memoryLimit),
      },
      {
        type: 'diskSpace',
        title: messages.diskSpace,
        bgColor: '',
        hidden: cluster,
        count: diskTotal,
        used: diskUsed,
        unit: diskUnit,
        warning: Number(diskUsed) > Number(diskLimit),
      },
      {
        type: 'service',
        title: messages.service,
        bgColor: 'blue',
        hidden: false,
        count: totalService,
        used: totalRunningService,
      },
      {
        type: 'extendedService',
        title: messages.extendedService,
        bgColor: 'red',
        hidden: false,
        count: totalExtService,
        used: totalExtRunningService,
      },
      {
        type: 'hostCount',
        title: messages.hostCount,
        bgColor: 'red',
        hidden: !cluster,
        count: totalHost,
        used: totalRunning,
      },
    ];

    setProgressData(progressList);
  };

  // 获取supos信息
  const getPlatformInfoFn = () => {
    getSuposAllConfig().then((res: any) => {
      setPlatformInfo(res.data);
    });
  };

  // 操作supos  启动 停止  重启 升级
  const changeStatus = (type: string) => {
    if (type === 'upgrade') return clickBtn('upgrade');
    if (type === 'dilatationNode') return setVisibleDilatationNode(true);
    if (type === 'checkEnv') return setCheckEnvVisible(true);

    // 除了重启 其他的操作需要二次弹框
    if (type === 'start') return operationSupos(1);
    confirm({
      content: intl.formatMessage(messages[`${type}Tip`], { version: '' }),
      onOk: () => {
        const typeObj: any = { start: 1, stop: 2, restart: 3, rollback: 7 };
        operationSupos(typeObj[type]);
      },
    });
  };
  // 显示/隐藏告警阈值
  const toggleModalVisible = () => {
    setVisible(!visible);
  };

  const togglePlatformConfigVisible = () => {
    if (statusText !== 'stopped' || percent) return;
    setPlatformConfigVisible(!platformConfigvisible);
    form.resetFields();
  };

  // 保存告警阈值配置
  const handleSaveAlarmConfig = () => {
    if (!AlertCongfigRef.current) return;
    AlertCongfigRef.current.form.validateFields((err: any, values: any) => {
      if (err) return;
      const body = [
        {
          podName: 'Ubuntu-All',
          namespace: 'Ubuntu-All',
          podIp: '',
          ...values,
        },
      ];
      setAlarmConfigApi(body).then(() => {
        message.success(intl.formatMessage(messages.success));
        setVisible(false);
        getAlarmConfigData();
        getSummary();
      });
    });
  };
  // 保存supos配置
  const handleSavePlatfromConfig = () => {
    validateFields(['cpu', 'mem', 'webPort'], (err, values) => {
      if (err) return;
      // 点击确认二次弹框
      confirm({
        content: <span>{intl.formatMessage(messages.confirmTip)}</span>,
        onOk: () => {
          // 修改平台设置
          modifySuposConfig({ supos: { ...values } }).then(() => {
            getPlatformInfoFn();
            operationSupos(4);
            setPlatformConfigVisible(false);
          });
        },
      });
    });
  };
  // 操作supos
  const operationSupos = (type: number) => {
    operationSuposApi({ name: 'supos', type }).then(() => {
      getStatus();
    });
  };

  // 轮询获取状态
  const loopGetData = () => {
    if (unmountedRef.current) return;
    clearTimeout(loopTimer);

    loopTimer = setTimeout(() => {
      getStatus();
      getSummary();
      getBasicInfo();
    }, 1000 * 10);
  };

  // 卸载确认
  const handleUninstall = (name: string) => {
    // 卸载supos，需要卸载所有组件
    unInstall({ name }).then(() => {
      getStatus();
    });
  };

  // 扩容
  const handDilatationNodeCancel = () => {
    setVisibleDilatationNode(false);
  };
  // 改变loading状态
  const changeLoading = (name: string, loading: boolean) => {
    setloadingObj({ name, loading });
  };
  useEffect(() => {
    renderProgress();
  }, [progressData]);

  const renderProgress = () => {
    return progressData.map((item: any, index: number) => {
      if (item.hidden) return '';

      return (
        <div key={index} className={styles.progress}>
          <ProgressComm
            percentage={item.used / item.count || 0}
            id={'canvas' + index}
            warning={item.warning || false}
          />

          <div className={styles.progressText}>
            <p>{intl.formatMessage(item.title)}</p>
            <span>{`${item.used}/${item.count}${item.unit || ''}`}</span>
          </div>
        </div>
      );
    });
  };

  return (
    <Spin spinning={spinning || loadingObj.loading} wrapperClassName={styles.wrap}>
      <div className={styles.container}>
        <div className={styles.left}>
          {[
            'waiting',
            'uninstalling',
            'upgrading',
            'non_disruptive_upgrading',
            'disruptive_upgrading',
            'rollback',
            'rolling_back',
          ].includes(statusText) ? (
            <InstallList showSupOS={true} catalog="system" />
          ) : (
            <>
              <div className={styles.success}>
                <div className={`${styles.statusBox} ${styles[statusText]}`}>
                  <img src={supOSLogo} />
                  <div className={`${styles.statusText} ${styles[statusText]}`}>
                    {statusText ? intl.formatMessage(messages[statusText]) : ''}
                  </div>
                </div>
                <div className={styles.version}>
                  <h3 className={styles.title}>supOS</h3>
                  <p>{baseInfo.supOsVersion}</p>
                  <div className={styles.progressGroup}>{renderProgress()}</div>
                </div>
              </div>
              <div className={styles.btnGroup}>
                {statusData &&
                  statusData.length !== 0 &&
                  statusData.map((item) => {
                    return (
                      <Button
                        key={item.type}
                        onClick={() => changeStatus(item.type)}
                        className={
                          disable && item.type !== 'checkEnv'
                            ? `${styles[item.bgColor]} ${styles.disable}`
                            : `${styles[item.bgColor]}`
                        }
                        disabled={item.type === 'checkEnv' ? false : disable}
                        style={item.hidden ? { display: 'none' } : {}}
                      >
                        {intl.formatMessage(item.title)}
                      </Button>
                    );
                  })}
                <PopoverDelete
                  className={styles.popover}
                  deleteTip={intl.formatMessage(messages.systemUninstallTip)}
                  deleteCallback={() => handleUninstall('supos')}
                  name="supos"
                  page="suposUpgrade"
                  changeLoading={changeLoading}
                />
              </div>
            </>
          )}
        </div>

        <div className={styles.infoBox}>
          <div className={styles.infoContent} style={cluster ? { height: '384px' } : { height: '215px' }}>
            <h2 className={styles.infoTitle}>{intl.formatMessage(messages.baseMsg)}</h2>
            <ul>
              <li>
                <span className={styles.label}>{intl.formatMessage(messages.systemName)} ：</span>
                <span className={styles.item}>{baseInfo.supOsName}</span>
              </li>
              <li>
                <span className={styles.label}>{intl.formatMessage(messages.deploymentMode)} ：</span>
                <span className={styles.item}>
                  {baseInfo.deployMode === 1
                    ? intl.formatMessage(messages.clusterDeploy)
                    : intl.formatMessage(messages.singleDeploy)}
                </span>
              </li>
              <li>
                <span className={styles.label}>{intl.formatMessage(messages.authorizedAddress)} ：</span>
                <a href={baseInfo.authorizeAddress} className={styles.link}>
                  <Icon type="link16" className={styles.linkIcon} />
                </a>
              </li>
              <li style={{ height: '44px' }}>
                <span className={styles.label}>{intl.formatMessage(messages.systemTime)} ：</span>
                <span>
                  {baseInfo?.timeInfo?.systemTime
                    ? moment(baseInfo?.timeInfo?.systemTime)
                        .tz(baseInfo?.timeInfo?.timezone)
                        .format('YYYY[年]MM[月]DD[日] HH:mm')
                    : ''}
                </span>
              </li>
            </ul>
          </div>
          {!cluster && (
            <div className={styles.infoContent}>
              <div className={styles.flex}>
                <h2 className={styles.infoTitle}>
                  {intl.formatMessage(messages.platformConfig)}
                  {statusText !== 'stopped' || percent ? (
                    <Tooltip title={intl.formatMessage(messages.pleaseStopSupos)}>
                      <span>
                        <Icon
                          type="edit161"
                          className={`${styles.editIcon} ${styles.disable}`}
                          onClick={togglePlatformConfigVisible}
                        />
                      </span>
                    </Tooltip>
                  ) : (
                    <span>
                      <Icon type="edit161" className={`${styles.editIcon}`} onClick={togglePlatformConfigVisible} />
                    </span>
                  )}
                </h2>
                {percent && statusText === 'stopped' ? (
                  <span className={styles.updatingText}>
                    {`${intl.formatMessage(messages.updating)}`}&nbsp;&nbsp;
                    <Spin size="small" />
                  </span>
                ) : null}
              </div>
              <ul>
                <li>
                  <span className={styles.label}>CPU ：</span>
                  <span className={styles.item}>{supos.cpu}vC</span>
                </li>
                <li>
                  <span className={styles.label}>{intl.formatMessage(messages.availableMemory)} ：</span>
                  <span className={styles.item}>{supos.mem}G</span>
                </li>
                <li>
                  <span className={styles.label}>{intl.formatMessage(messages.port)} ：</span>
                  <span className={styles.item}>{supos.webPort}</span>
                </li>
              </ul>
            </div>
          )}
        </div>
        <div className={styles.infoBox}>
          <SystemNotice suposStatus={statusText} record={sysTimeData} className={styles.infoContent} />
          <div className={styles.infoContent}>
            <h2 className={styles.infoTitle}>
              {intl.formatMessage(messages.alarmThreshold)}
              <Icon type="edit161" className={styles.editIcon} onClick={toggleModalVisible} />
            </h2>
            <ul>
              <li>
                <span className={styles.label}>
                  CPU ：{alarmConfig.cpuLimit}%，{intl.formatMessage(messages.duration)}
                  {alarmConfig.cpuTime}min
                </span>
              </li>
              <li>
                <span className={styles.label}>
                  {intl.formatMessage(messages.memory)}：{alarmConfig.memoryLimit}%，
                  {intl.formatMessage(messages.duration)}
                  {alarmConfig.memoryTime}min
                </span>
              </li>
              <li>
                <span className={styles.label}>
                  {intl.formatMessage(messages.disk)}：{alarmConfig.diskLimit}%，
                  {intl.formatMessage(messages.duration)}
                  {alarmConfig.diskTime}min
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* 警告阈值 */}
        <AlertConfig
          wrappedComponentRef={AlertCongfigRef}
          title={intl.formatMessage(messages.alarmThreshold)}
          visible={visible}
          onOk={handleSaveAlarmConfig}
          onCancel={toggleModalVisible}
          dataInfo={alarmConfig}
        />

        {/* 平台配置弹框 */}
        <Modal
          title={intl.formatMessage(messages.editPlatformConfig)}
          visible={platformConfigvisible}
          onOk={handleSavePlatfromConfig}
          onCancel={togglePlatformConfigVisible}
          className={styles.platformModal}
          height="auto"
          width="556px"
        >
          <Form {...platformFormItemLayout}>
            <Form.Item label={intl.formatMessage(messages.availableCPU)}>
              {getFieldDecorator('cpu', {
                initialValue: supos.cpu,
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.cpuNull),
                  },
                  {
                    validator: (rule: any, value: string, callbackFn: Function) => {
                      if (Number(value) < 13) {
                        callbackFn(intl.formatMessage(messages.cpuMinError));
                      }
                      if (String(value).indexOf('.') >= 0) {
                        callbackFn(intl.formatMessage(messages.decimalError));
                      }
                      if (supos.cpuLimit && Number(value) > Number(supos.cpuLimit)) {
                        callbackFn(`${intl.formatMessage(messages.cpuMaxError)}${supos['cpuLimit']}vC`);
                      }
                      callbackFn();
                    },
                  },
                ],
              })(<InputNumber />)}
              <span className={styles.unit}> 13 -{supos['cpuLimit']}vC</span>
            </Form.Item>
            <Form.Item label={intl.formatMessage(messages.availableMemory)}>
              {getFieldDecorator('mem', {
                initialValue: supos.mem,
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.memoryNull),
                  },
                  {
                    validator: (rule: any, value: string, callbackFn: Function) => {
                      if (Number(value) < 27) {
                        callbackFn(intl.formatMessage(messages.memoryMinError));
                      }
                      if (String(value).indexOf('.') >= 0) {
                        callbackFn(intl.formatMessage(messages.decimalError));
                      }
                      if (Number(value) > supos['memLimit']) {
                        callbackFn(`${intl.formatMessage(messages.memoryMaxError)}${supos['memLimit']}G`);
                      }
                      callbackFn();
                    },
                  },
                ],
              })(<InputNumber />)}
              <span className={styles.unit}> 27 - {supos['memLimit']}G</span>
            </Form.Item>
            <Form.Item label={intl.formatMessage(messages.port)}>
              {getFieldDecorator('webPort', {
                initialValue: supos.webPort,
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.portNull),
                  },
                  {
                    validator: (rule: any, value: string, callbackFn: Function) => {
                      const result = platformInfo.supos.reservedPortsForWeb.some((item: any) => item === String(value));
                      if (result) {
                        callbackFn(intl.formatMessage(messages.reservedPortError));
                      }
                      callbackFn();
                    },
                  },
                  {
                    message: intl.formatMessage(messages.portError),
                    pattern: new RegExp(
                      /^([1-9](\d{0,3}))$|^([1-5]\d{4})$|^(6[0-4]\d{3})$|^(65[0-4]\d{2})$|^(655[0-2]\d)$|^(6553[0-5])$/,
                    ),
                  },
                ],
              })(<InputNumber />)}
            </Form.Item>
          </Form>
        </Modal>
      </div>
      <ExtendedService ref={extendedServiceRef} />
      <DilatationNode
        wrappedComponentRef={DilatationNodeRef}
        visible={visibleDilatationNode}
        onCancel={handDilatationNodeCancel}
        record={sysTimeData}
        limitPastTime={true}
      />
      <CheckEnv visible={checkEnvVisible} setVisible={setCheckEnvVisible} />
    </Spin>
  );
};

export default Form.create()(PlatformManage);
